module.exports = __webpack_public_path__ + "static/media/user-past.6cc0d6d3.svg";